module.exports = __webpack_public_path__ + "static/media/champion06.fd8fcd87.jpg";